import QuickInfo from './QuickInfo';

export default QuickInfo;
export { QuickInfo };
